import { createContext as r, useContext as n, useMemo as t, useCallback as e, useEffect as o, forwardRef as i, useState as u, useRef as a, useImperativeHandle as c } from "react";
import f from "dot-object";
import { jsx as l } from "react/jsx-runtime";
var s = r({});

function p(r) {
  var i = n(s),
      u = i.initialData,
      a = i.errors,
      c = i.scopePath,
      l = i.unregisterField,
      p = i.registerField,
      v = i.clearFieldError;
  if (!r) throw new Error('You need to provide the "name" prop.');
  var d = t(function () {
    return c ? c + "." + r : r;
  }, [r, c]),
      h = t(function () {
    return f.pick(d, u);
  }, [d, u]),
      b = t(function () {
    return a[d];
  }, [a, d]),
      y = e(function () {
    v(d);
  }, [v, d]);
  return o(function () {
    return function () {
      return l(d);
    };
  }, [d, l]), {
    fieldName: d,
    registerField: p,
    defaultValue: h,
    clearError: y,
    error: b
  };
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */


var _v = function v() {
  return (_v = Object.assign || function (r) {
    for (var n, t = 1, e = arguments.length; t < e; t++) {
      for (var o in n = arguments[t]) {
        Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
      }
    }

    return r;
  }).apply(this, arguments);
};

function d(r, n) {
  var t,
      e,
      o,
      i,
      u = {
    label: 0,
    sent: function sent() {
      if (1 & o[0]) throw o[1];
      return o[1];
    },
    trys: [],
    ops: []
  };
  return i = {
    next: a(0),
    throw: a(1),
    return: a(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;

  function a(i) {
    return function (a) {
      return function (i) {
        if (t) throw new TypeError("Generator is already executing.");

        for (; u;) {
          try {
            if (t = 1, e && (o = 2 & i[0] ? e.return : i[0] ? e.throw || ((o = e.return) && o.call(e), 0) : e.next) && !(o = o.call(e, i[1])).done) return o;

            switch (e = 0, o && (i = [2 & i[0], o.value]), i[0]) {
              case 0:
              case 1:
                o = i;
                break;

              case 4:
                return u.label++, {
                  value: i[1],
                  done: !1
                };

              case 5:
                u.label++, e = i[1], i = [0];
                continue;

              case 7:
                i = u.ops.pop(), u.trys.pop();
                continue;

              default:
                if (!(o = u.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                  u = 0;
                  continue;
                }

                if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                  u.label = i[1];
                  break;
                }

                if (6 === i[0] && u.label < o[1]) {
                  u.label = o[1], o = i;
                  break;
                }

                if (o && u.label < o[2]) {
                  u.label = o[2], u.ops.push(i);
                  break;
                }

                o[2] && u.ops.pop(), u.trys.pop();
                continue;
            }

            i = n.call(r, u);
          } catch (r) {
            i = [6, r], e = 0;
          } finally {
            t = o = 0;
          }
        }

        if (5 & i[0]) throw i[1];
        return {
          value: i[0] ? i[1] : void 0,
          done: !0
        };
      }([i, a]);
    };
  }
}

var h = i(function (r, n) {
  var t = r.initialData,
      o = void 0 === t ? {} : t,
      i = r.children,
      p = r.onSubmit,
      h = u({}),
      b = h[0],
      y = h[1],
      m = a([]),
      g = e(function (r) {
    return m.current.find(function (n) {
      return n.name === r;
    });
  }, []),
      w = e(function (r) {
    var n = r.ref,
        t = r.getValue,
        e = r.path;
    return t ? t(n) : e && f.pick(e, n);
  }, []),
      E = e(function (r, n) {
    var t = r.path,
        e = r.ref,
        o = r.setValue;
    return o ? o(e, n) : !!t && f.set(t, n, e);
  }, []),
      F = e(function (r) {
    var n = r.clearValue,
        t = r.ref,
        e = r.path;
    return n ? n(t, "") : e && f.set(e, "", t);
  }, []),
      O = e(function (r) {
    void 0 === r && (r = {}), m.current.forEach(function (n) {
      var t = n.name,
          e = n.ref,
          o = n.path,
          i = n.clearValue;
      return i ? i(e, r[t]) : o && f.set(o, r[t] ? r[t] : "", e);
    });
  }, []),
      P = e(function (r) {
    var n = {};
    m.current.forEach(function (t) {
      n[t.name] = f.pick(t.name, r);
    }), Object.entries(n).forEach(function (r) {
      var n = r[0],
          t = r[1],
          e = g(n);
      e && E(e, t);
    });
  }, [g, E]),
      j = e(function (r) {
    var n = f.dot(r);
    y(n);
  }, []),
      x = e(function () {
    var r = {};
    return m.current.forEach(function (n) {
      r[n.name] = w(n);
    }), f.object(r), r;
  }, [w]),
      k = e(function (r) {
    return n = void 0, t = void 0, o = function o() {
      var n;
      return d(this, function (t) {
        return r && r.preventDefault(), n = x(), p(n, {
          reset: O
        }, r), [2];
      });
    }, new ((e = void 0) || (e = Promise))(function (r, i) {
      function u(r) {
        try {
          c(o.next(r));
        } catch (r) {
          i(r);
        }
      }

      function a(r) {
        try {
          c(o.throw(r));
        } catch (r) {
          i(r);
        }
      }

      function c(n) {
        n.done ? r(n.value) : new e(function (r) {
          r(n.value);
        }).then(u, a);
      }

      c((o = o.apply(n, t || [])).next());
    });
    var n, t, e, o;
  }, [p, x, O]),
      V = e(function (r) {
    m.current.push(r);
  }, []),
      D = e(function (r) {
    var n = m.current.findIndex(function (n) {
      return n.name === r;
    });
    n > -1 && m.current.splice(n, 1);
  }, []),
      S = e(function (r) {
    y(function (n) {
      var t;
      return _v(_v({}, n), ((t = {})[r] = void 0, t));
    });
  }, []);
  return c(n, function () {
    return {
      getFieldValue: function getFieldValue(r) {
        var n = g(r);
        return !!n && w(n);
      },
      setFieldValue: function setFieldValue(r, n) {
        var t = g(r);
        return !!t && E(t, n);
      },
      getFieldError: function getFieldError(r) {
        return b[r];
      },
      setFieldError: function setFieldError(r, n) {
        y(function (t) {
          var e;
          return _v(_v({}, t), ((e = {})[r] = n, e));
        });
      },
      clearField: function clearField(r) {
        var n = g(r);
        n && F(n);
      },
      getErrors: function getErrors() {
        return b;
      },
      setErrors: function setErrors(r) {
        return j(r);
      },
      getData: function getData() {
        return x();
      },
      getFieldRef: function getFieldRef(r) {
        var n = g(r);
        return !!n && n.ref;
      },
      setData: function setData(r) {
        return P(r);
      },
      reset: function reset(r) {
        return O(r);
      },
      submitForm: function submitForm() {
        k();
      }
    };
  }), l(s.Provider, _v({
    value: {
      initialData: o,
      errors: b,
      scopePath: "",
      registerField: V,
      unregisterField: D,
      clearFieldError: S,
      handleSubmit: k
    }
  }, {
    children: i
  }), void 0);
});

function b(r) {
  var t = r.path,
      e = r.children,
      o = n(s),
      i = o.scopePath,
      u = function (r, n) {
    var t = {};

    for (var e in r) {
      Object.prototype.hasOwnProperty.call(r, e) && n.indexOf(e) < 0 && (t[e] = r[e]);
    }

    if (null != r && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (e = Object.getOwnPropertySymbols(r); o < e.length; o++) {
        n.indexOf(e[o]) < 0 && Object.prototype.propertyIsEnumerable.call(r, e[o]) && (t[e[o]] = r[e[o]]);
      }
    }

    return t;
  }(o, ["scopePath"]);

  return l(s.Provider, _v({
    value: _v(_v({}, u), {
      scopePath: i.concat(i ? "." + t : t)
    })
  }, {
    children: e
  }), void 0);
}

export { s as FormContext, h as FormProvider, b as Scope, p as useField };